export class ScrollPerformanceOptimizer {
  constructor(disableHoverClass = 'u-disable-hover', delay = 500) {
    this.body = document.body;
    this.timer = null;
    this.disableHoverClass = disableHoverClass;
    this.delay = delay;

    this.init();
  }

  init() {
    this.optimizeScrollPerformance();
  }

  optimizeScrollPerformance() {
    window.addEventListener('scroll', () => {
      clearTimeout(this.timer);
      if (!this.body.classList.contains(this.disableHoverClass)) {
        this.body.classList.add(this.disableHoverClass);
      }

      this.timer = setTimeout(() => {
        this.body.classList.remove(this.disableHoverClass);
      }, this.delay);
    }, {passive: true});
  }
}
